import { useCallback, useEffect, useState } from "react";

const useCelloAttribution = () => {
    const [ucc, setUcc] = useState(null);

    const initializeCelloAttribution = useCallback(() => {
        if (!window.CelloAttribution) {
            window.CelloAttribution = async function (t, ...o) {
                if (t === "getReferral") {
                    throw new Error("getReferral is not supported in this context. Use getUcc instead.");
                }

                let resolve, reject;
                const promise = new Promise((res, rej) => {
                    resolve = res;
                    reject = rej;
                });

                if (!window.CelloAttributionCmd) {
                    window.CelloAttributionCmd = [];
                }

                window.CelloAttributionCmd.push({
                    command: t,
                    args: o,
                    resolve,
                    reject,
                });

                return promise;
            };
        }
    }, []);

    useEffect(() => {
        const fetchUcc = async () => {
            if (!window.CelloAttribution) return;

            try {
                const uccValue = await window.CelloAttribution("getUcc");
                setUcc(uccValue);
            } catch (error) {
                console.error("Error fetching UCC:", error);
            }
        };

        fetchUcc();
    }, [initializeCelloAttribution]);

    return { initializeCelloAttribution, ucc };
};

export default useCelloAttribution;
